
import { Options, Vue } from "vue-class-component"; //基本需要\
import fileSaver from "file-saver";
import * as XLSX from "xlsx";
import roma from "../assets/json1/roma.js";
import * as echarts from "echarts";
import passion1 from "@/assets/js/passion1.js";
import { store } from "@/store"; //引入仓库
import { ElMessage } from "element-plus";
import { dispatchGetDeviceSpecs } from "@/store/device/actions";
import { readDeviceSpecs } from "@/store/device/getters";

import {
  readPerfDashboard,
  readPerformancePageList,
  readPerformanceSelectOptions,
  readArrange,
} from "@/store/performance/getters";
import {
  compare,
  dateConversion,
  getLocalProject,
  special_projects,
  unique_json,
} from "@/utils";
import {
  dispatchGetSkinTableReport,
  dispatchGetPerformanceSelectOptions,
  dispatchGetArrange,
  dispatchGetArrangeByXlsx,
} from "@/store/performance/actions";
// import God from "@/assets/js/god.js";
import { readSkinReportTableData } from "@/store/performance/getters";
export default class TestReport extends Vue {
  parseTable(elId) {
    const thead = document.querySelector(`${elId} .el-table__header-wrapper table`),
      bodyEl = document.querySelector(`${elId} .el-table__body-wrapper table`),
      headers = Array.from(thead.querySelectorAll('th')).map(th => th.textContent.trim()),
      rows = [],
      merges = []

    headers.forEach((th, colIndex) => {
      merges.push({
        s: { r: 0, c: colIndex}, // 起始单元格
        e: { r: 0, c: colIndex}, // 结束单元格
      })
    })

    //获取表格数据
    const tbody = document.querySelector(`${elId} .el-table__body-wrapper table`)
    if (tbody) {
      const trs = tbody.querySelectorAll("tr")
      trs.forEach((tr, rowIndex) => {
        const cells = tr.querySelectorAll("td")
        const rowData = [];
        cells.forEach((cell, colIndex) => {
          // 获取单元格内容
          let cellContent = cell.textContent.trim();

          // 检查是否有合并单元格
          const rowSpan = cell.getAttribute("rowspan");
          const colSpan = cell.getAttribute("colspan");

          if (rowSpan || colSpan) {
            // 记录合并单元格
            merges.push({
              s: { r: rowIndex + 1, c: colIndex }, // 起始单元格
              e: { r: rowIndex + 1 + (rowSpan ? parseInt(rowSpan) - 1 : 0), c: colIndex + (colSpan ? parseInt(colSpan) - 1 : 0) }, // 结束单元格
            });
          }

          rowData.push({cellContent, rowSpan, colSpan})
        })

        rows.push(rowData)
      })
    }

    return { headers, rows, merges}
  }

  handleRows(rows) { //将空缺的td补上
    for (let [rowIndex, row] of rows.entries()) {
      for (let [colIndex, td] of row.entries()) {
        if (td.rowSpan > 1) {
          for (let i=0; i < (td.rowSpan - 1); i++) {
            const nextRow = rows[rowIndex + i + 1]
            nextRow.splice(colIndex, 0, {cellContent: ''})
          }
        }
      }
    }

    return rows.map(row => {
      return row.map(td => td.cellContent)
    })
  }

  appendWs(wb, elId, sheetName) {
    let {headers, rows, merges} = this.parseTable(elId)
    rows = this.handleRows(rows)
    const data = [headers, ...rows]
    const ws = XLSX.utils.aoa_to_sheet(data)
    //设置合并单元格
    if (merges.length > 0) {
      ws["!merges"] = merges;
    }
    //将工作表添加到工作簿
    XLSX.utils.book_append_sheet(wb, ws, sheetName)
  }

  exportTable() {
    const wb = XLSX.utils.book_new()

    for (let i=0; i<this.indicator_value.length; i++) {
      let title = this.index_key.filter((m) => m.value == this.indicator_value[i])[0].name
      title = title.slice(0, 31)
      this.appendWs(wb, `#skin-table${i}`, title)
    }
    //导出 Excel 文件
    XLSX.writeFile(wb, '皮肤表格.xlsx')
  }

  public localProject = Number(getLocalProject()) //得到本地的项目
  public b = "40%";
  public loading = false;
  public url = "";
  public getId(data, ary) {
    let string = "";
    ary.forEach((v) => {
      if (data[v]) {
        string = data[v]?.skin_id;
      }
    });
    return string;
  }
  public getAction(data, ary) {
    let string = "";
    ary.forEach((v) => {
      if (data[v]) {
        string = data[v]?.action;
      }
    });
    return string;
  }
  public downloadCsv(elId = "#detailTable") {
    this.$nextTick(() => {
      var xlsxParam = { raw: true }; // 导出的内容只做解析，不进行格式转换，保证时间格式或者较长数字不会出现科学计数法。（这个很关键）
      var wb = XLSX.utils.table_to_book(
        document.querySelector(elId),
        xlsxParam
      );
      /* 获取二进制字符串作为输出 */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        fileSaver?.saveAs(
          //Blob 对象表示一个不可变、原始数据的类文件对象。
          //Blob 表示的不一定是JavaScript原生格式的数据。
          //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
          //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
          new Blob([wbout], { type: "application/octet-stream" }),
          //设置导出文件名称
          this.type + ".xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }

      return wbout;
    });
  }
  public removeBtn(i, p, x) {
    if (this.type == "皮肤表格") {
      this.general_tables_data.splice(i, 1);
    } else {
      i.splice(p, 1);
      if (i.length == 0) {
        this.general_tables_data_auto.splice(x, 1);
      }
    }
  }
  public mergeCells2({ row, column, rowIndex, columnIndex }) {
    if (columnIndex === 0) {
      const rowCount = this.autoTableData.filter(
        (item) => item.name === row.name
      ).length;
      if (rowCount > 1) {
        const isFirstRow =
          this.autoTableData.findIndex((item) => item.name === row.name) ===
          rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
  }
  public spanMethod({ row, column, rowIndex, columnIndex }) {
    if (columnIndex === 0) {
      const prevRow = this.skinData[rowIndex - 1];

      if (prevRow && prevRow.name === row.name) {
        return {
          rowspan: 0,
          colspan: 0,
        };
      } else {
        const rowspan = this.skinData.filter((item) => item.name === row.name)
          .length;
        return {
          rowspan,
          colspan: 1,
        };
      }
    }
  }
  public get getDeviceSpecs() {
    return readDeviceSpecs(store);
  }
  public addrow(text) {
    let list = [{ device: "", scene: "", url: "", file: "" }];
    this.general_tables_data_auto.push(list);
  }
  public get performace_select_options() {
    const options = readPerformanceSelectOptions(store);
    return options;
  }
  public is_label1 = true;
  public get device_options() {
    const devices = this.performace_select_options.device_list;
    const device_select: any[] = [];
    devices.forEach((item) => {
      const device = this.getDeviceSpecs.filter(
        (device) => device.id === item
      )[0];
      const name =
        device?.level +
        1 +
        "档机 - " +
        device?.model?.name +
        " - " +
        device?.model?.model;
      device_select.push({
        label: name,
        value: item,
        level: device?.level + 1,
      });
    });
    // 分组排序
    let map = {};
    let dest = [];
    for (let i = 0; i < device_select.length; i++) {
      let ai = device_select[i];
      if (!(map as any)[ai.level]) {
        dest.push({
          level: ai.level,
          label: ai.level + "档机",
          data: [ai],
        });
        (map as any)[ai.level] = ai;
      } else {
        for (let j = 0; j < dest.length; j++) {
          let dj = dest[j];
          if (dj.level == ai.level) {
            dj.data.push(ai);
            break;
          }
        }
      }
    }
    return dest.sort(compare("level"));
  }
  public skinData = [];
  public uploadedFiles = [];
  public findFlattenedIndex(list, outerIndex, innerIndex) {
    let flattenedIndex = 0;

    for (let i = 0; i < outerIndex; i++) {
      flattenedIndex += list[i].length;
    }

    flattenedIndex += innerIndex;

    return flattenedIndex;
  }
  public formData: any = new FormData();
  ploadImage(param, fileList, index, i) {
    // console.log("当前点击的是第几行:", index,file);

    let parmIndex = this.findFlattenedIndex(
      this.general_tables_data_auto,
      index,
      i
    );

    if (param.file === undefined) {
      document
        .getElementsByClassName("el-upload")
        [parmIndex].setAttribute("style", "display: inline-block");
    } else {
      document
        .getElementsByClassName("el-upload")
        [parmIndex].setAttribute("style", "display: none");
    }

    this.general_tables_data_auto[index][i].file = param.file;
    // console.log(this.uploadedFiles);
  }
  public skinData_all() {
    this.skinData = [];
    if (this.url.indexOf("test_report_skin_inside") == -1) {
      for (let i in readSkinReportTableData(store).inside_skin_list) {
        for (let k in readSkinReportTableData(store).inside_skin_list[i]) {
          this.skinData.push({
            name: i,
            data: readSkinReportTableData(store).inside_skin_list[i][k],
          });
        }
      }
    } else {
      for (let i in readSkinReportTableData(store).inside_skin_list) {
        this.skinData.push({
          name: i,
          data: readSkinReportTableData(store).inside_skin_list[i],
        });
      }
    }

    return this.skinData;
  }
  public getData(data, i, k) {
    let string: any = "";
    if (data[i]) {
      if (data[i][k]) {
        string = data[i][k];
      } else {
        string = 0;
      }
    } else {
      string = "";
    }
    return string;
  }
  public get skinData_head() {
    return readSkinReportTableData(store).device_list;
  }
  public handleSelectAll2(type) {
    if (type === "open") {
      let keys = this.index_key.map((v) => v.value);
      this.indicator_value = keys;
    } else {
      this.indicator_value = [];
    }
  }
  public coloum_width(name) {
    if (name == "通用表格-自动") {
      return 250;
    } else {
      return 150;
    }
  }
  public indicator_value = [];
  public index_key = [
    { name: "帧率均值", value: "avg_fps" },
    { name: "最低帧", value: "min_fps" },
    { name: "帧率方差", value: "var_fps" },
    { name: "低于40帧占比(%)", value: "fps_lt_18_pcnt" },
    { name: "低于20帧占比(%)", value: "fps_lt_20_pcnt" },
    { name: "CPU占用均值(%)", value: "avg_cpu" },
    { name: "PSS均值(MB)", value: "avg_pss" },
    { name: "PSS峰值(MB)", value: "max_pss" },
    { name: "VSS峰值(MB)", value: "max_vss" },
    { name: "VSS均值(MB)", value: "avg_vss" },
    { name: "MonoUpdateFrameTime", value: "MonoUpdateFrameTime" },
    { name: "MonoLateUpdateFrameTime", value: "MonoLateUpdateFrameTime" },
    { name: "PlayerRenderFrameTime", value: "PlayerRenderFrameTime" },
    { name: "FlushGameCoreFifoFrameTime", value: "FlushGameCoreFifoFrameTime" },
    {
      name: "InterpolationLateUpdateFrameTime",
      value: "InterpolationLateUpdateFrameTime",
    },
  ];
  public auto_list = [
    { name: "整局FPS", value: "avg_fps" },
    { name: ">25帧占比", value: "fps_lt_25_pcnt" },
    { name: "平均CPU", value: "avg_cpu" },
    { name: " CPU<60占有率(%)", value: "cpu_lt_60_pcnt" },
    { name: "pss峰值", value: "max_pss" },
    { name: "pss均值", value: "avg_pss" },
    { name: "vss峰值", value: "max_vss" },
    { name: "vss均值", value: "avg_vss" },

    { name: "jank", value: "jank" },
    { name: "big_jank", value: "big_jank" },
  ];
  public metrics = [
    { name: "loading时长", value: "loadingtime" },
    // {name:'>25帧占比',value:'fps_lt_25_pcnt'},
    { name: "流量(KB/S)", value: "avg_flow" },
    { name: "FPS>18占有率(%)", value: "fps_lt_18_pcnt" },
    { name: "FPS>40占有率(%)", value: "fps_lt_40_pcnt" },
    { name: "功耗", value: "cpu_power" },
  ];
  public cpu_power_list = [
    { name: "CPU0功耗", value: "cpu_power_0" },
    { name: "CPU1功耗", value: "cpu_power_1" },
    { name: "CPU2功耗", value: "cpu_power_2" },
    { name: "CPU3功耗", value: "cpu_power_3" },
    { name: "CPU4功耗", value: "cpu_power_4" },
    { name: "CPU5功耗", value: "cpu_power_5" },
    { name: "CPU6功耗", value: "cpu_power_6" },
    { name: "CPU7功耗", value: "cpu_power_7" },
  ];
  public get name_list() {
    let list = [];
    if (JSON.stringify(readSkinReportTableData(store)) != "{}") {
      if (
        Object.keys(readSkinReportTableData(store)?.inside_skin_list).length > 0
      ) {
        list = Object.keys(readSkinReportTableData(store).inside_skin_list);
        list.push("All");
        this.unique(list);
      }
    }
    // console.log(list);
    return list;
  }
  public skin_change() {
    if (this.skin_name !== "All") {
      this.skinData = [];
      if (this.url.indexOf("test_report_skin_inside") != -1) {
        this.skinData.push({
          name: this.skin_name,
          data: readSkinReportTableData(store).inside_skin_list[this.skin_name],
        });
      } else {
        for (let i in readSkinReportTableData(store).inside_skin_list[
          this.skin_name
        ]) {
          this.skinData.push({
            name: this.skin_name,
            data: readSkinReportTableData(store).inside_skin_list[
              this.skin_name
            ][i],
          });
        }
      }
    } else {
      this.skinData_all();
    }
  }
  public skin_name = "";
  public unique(array) {
    for (let i = 0; i < array.length; i++) {
      for (let j = i + 1; j < array.length; j++) {
        if (array[i] === array[j]) {
          array.splice(j, 1);
          j--;
        }
      }
    }
    return array;
  }
  public type_change() {
    if (this.type !== "皮肤表格") {
      this.general_tables_data = [{ device: "", scene: "", url: "", file: "" }];
      this.general_tables_data_auto = [
        [{ device: "", scene: "", url: "", file: "" }],
      ];
      this.auto_value = [];
      this.autoTableData = [];
      this.auto_change_list = [];
      this.cpu_list = [];
      this.is_label1 = true;
    }
  }
  public handleSelectAll3(type) {
    if (type === "open") {
      this.auto_value = this.metrics.map((v) => v.value);
      this.auto_change_list = this.metrics.filter((v) => {
        if (v.name !== "功耗") {
          return this.auto_value.includes(v.value);
        }
      });
      // console.log(this.auto_value);
      this.cpu_list = this.cpu_power_list;
    } else {
      this.auto_value = [];
      this.auto_change_list = [];
      this.cpu_list = [];
    }
  }
  public autoTableData = [];
  public async arrfim(type) {
    if (this.type == "皮肤表格") {
      const urlString = this.url;

      // const urlString = "https://gr.woa.com/test_report_skin_inside?project=34&id_test=68115";
      const url = new URL(urlString);
      const params = new URLSearchParams(url.search);
      const reportId = params.get("report_id");
      if (this.url.indexOf("test_report_skin_inside") != -1) {
        await dispatchGetSkinTableReport(store, {
          project: this.localProject,
          report_id: Number(reportId),
          type: "inside",
        });
      } else {
        await dispatchGetSkinTableReport(store, {
          project: this.localProject,
          report_id: Number(reportId),
          type: "outside",
        });
      }

      this.skinData_all();
      this.skin_name = "All";
    }
    if (this.type == "通用表格-自动") {
      let b = (this as any).$message({
        //Message 消息提示
        message: "数据获取中,请等待....",
        showClose: true,
        duration: 0,
      });
      let i = [];

      this.general_tables_data_auto.forEach((j, index) => {
        let list = j.map((v) => {
          let report_id = v.url
            ? new URLSearchParams(new URL(v.url).search)?.get("report_id")
            : "";
          return { scene: v.scene, report_id: report_id, group: index };
        });
        i.push(list);
      });

      let list = this.general_tables_data.flat().map((v) => {
        let report_id = v.url
          ? new URLSearchParams(new URL(v.url).search)?.get("report_id")
          : "";
        return { scene: v.scene, report_id: report_id };
      });
      // console.log(list);

      await dispatchGetArrange(store, {
        project: this.localProject,
        json_str: i
          .flat()
          .filter((item) => item.scene !== "" || item.report_id !== ""),
      });
      b.close();
      ElMessage.success({
        message: "数据获取成功",
        showClose: true,
        type: "success",
      });
      this.autoTableData = [];

      for (let i in this.auto_tale_data) {
        this.auto_tale_data[i].forEach((v) => {
          this.autoTableData.push({ name: i, data: v });
        });
      }
    }

    if (this.type == "通用表格-人工") {
      let b = (this as any).$message({
        //Message 消息提示
        message: "数据获取中,请等待....",
        showClose: true,
        duration: 0,
      });
      this.formData = new FormData();
      let list = this.general_tables_data_auto.map((subList) =>
        subList.filter((item) => item.scene && item.device && item.file)
      );
      let scenes: any = list.map((v) => v.map((k) => k.scene));

      let devices: any = list.map((v) => v.map((k) => k.device));
      let groups: any = list.map((v, index) => v.map((k) => index));

      // let devices: any = this.general_tables_data.map((v) => v.device);
      // //  let files:any= this.general_tables_data.map(v=>
      // //     v.file
      // //   )
      this.formData.append("project", this.localProject);
      this.formData.append("scenes", scenes.flat());

      this.formData.append("devices", devices.flat());
      this.formData.append("is_label1", this.is_label1);
      this.formData.append("groups", groups.flat());

      // //  this.formData.append(`files`,'2');
      // this.general_tables_data.forEach((v, index) => {
      //   this.formData.append(`files`, v.file);
      // });
      list.forEach((v) => {
        v.forEach((n) => {
          this.formData.append(`files`, n.file);
        });
      });

      await dispatchGetArrangeByXlsx(store, this.formData);
      b.close();
      ElMessage.success({
        message: "数据获取成功",
        showClose: true,
        type: "success",
      });
      this.autoTableData = [];

      for (let i in this.auto_tale_data) {
        this.auto_tale_data[i].forEach((v) => {
          this.autoTableData.push({ name: i, data: v });
        });
      }
    }
  }
  public testData = [
    [
      { scene: "", url: "" },
      { scene: "", url: "" },
    ],
    [],
    [],
  ];
  public device_name(type) {
    let string = "";
    this.device_options.forEach((v) => {
      v.data.forEach((m) => {
        if (m.value == type) {
          string = m.label;
        }
      });
    });
    return string;
  }
  public get auto_tale_data() {
    return readArrange(store);
  }
  public url_check(url) {
    try {
      const urlParams = new URLSearchParams(new URL(url).search);
      const reportId = urlParams.get("report_id");
      return reportId;
      // 处理查询参数
    } catch (error) {
      ElMessage.error("测试数据链接不正确");
      return;
    }
  }
  public cpu_list = [];
  public auto_change_list = [];
  public autoChange() {
    this.auto_change_list = this.metrics.filter((v) => {
      if (v.name !== "功耗") {
        return this.auto_value.includes(v.value);
      }
    });
    if (this.auto_value.includes("cpu_power")) {
      this.cpu_list = this.cpu_power_list;
    } else {
      this.cpu_list = [];
    }
  }
  public auto_value: any = [];
  public async mounted() {
    //   let url='123'
    // this.url_check(url)
    this.type = "皮肤表格";
    let keys = this.index_key.map((v) => v.value);
    this.indicator_value = keys;
    dispatchGetDeviceSpecs(store, { project: this.localProject });
    await dispatchGetPerformanceSelectOptions(store, {
      project: this.localProject,
    });
  }
  public addrow_auto(row) {
    row.push({ device: "", scene: "", url: "", file: "" });
  }

  public type = "";
  public general_tables_data = [{ device: "", scene: "", url: "", file: "" }];
  public general_tables_data_auto = [
    [{ device: "", scene: "", url: "", file: "" }],
  ];
  //  '通用表格-自动','通用表格-人工'
  public type_list = ["皮肤表格", "通用表格-自动", "通用表格-人工"];
}
